import { render, staticRenderFns } from "./VMain.vue?vue&type=template&id=fea7554e&"
import script from "./VMain.vue?vue&type=script&lang=js&"
export * from "./VMain.vue?vue&type=script&lang=js&"
import style0 from "./VMain.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports